import { ModelTypes } from "types";
import { getModelTypeColor } from "helpers/utility/utilities";
import UserTagIcon from "assets/icons/UserTagIcon";
import TagIcon from "assets/icons/tagIcon";
import ObjectIcon from "assets/icons/ObjectIcon";
import CaptionIcon from "assets/icons/CaptionIcon";
import { SemanticImageSearchIcon } from "assets/icons/SemanticImageSearchIcon";
import { SemanticObjectSearchIcon } from "assets/icons/SemanticObjectSearchIcon";

import styles from "./style.module.scss";
import { InstanceRetrievalIcon } from "../../../assets/icons/InstanceRetrievalIcon";

interface ModelTypeBadgeProps {
  modelType: ModelTypes;
}

const ModelTypeBadge = ({ modelType }: ModelTypeBadgeProps) => {
  const { color, backgroundColor } = getModelTypeColor(modelType);
  const renderModelTypeIcon = (
    ModelType: ModelTypes,
    color: string,
  ): JSX.Element => {
    switch (ModelType) {
      case ModelTypes.CAPTION_IMAGES:
        return <CaptionIcon type="IMAGE" color={color} />;
      case ModelTypes.CAPTION_OBJECTS:
        return <CaptionIcon type="OBJECT" color={color} />;
      case ModelTypes.IMAGE_TAGGING:
        return <TagIcon color={color} />;
      case ModelTypes.OBJECT_TAGGING:
        return <TagIcon color={color} />;
      case ModelTypes.OBJECT_DETECTION:
        return <ObjectIcon color={color} />;
      case ModelTypes.MULTIMODEL_IMAGE_ENCODING:
        return <SemanticImageSearchIcon />;
      case ModelTypes.MULTIMODEL_OBJECT_ENCODING:
        return <SemanticObjectSearchIcon />;
      case ModelTypes.INSTANCE_RETRIEVAL:
        return <InstanceRetrievalIcon />;

      default:
        return <UserTagIcon color={color} />;
    }
  };

  const getModelTypeTitle = (modelType: ModelTypes): string => {
    switch (modelType) {
      case ModelTypes.CAPTION_IMAGES:
        return "IMAGE TO TEXT";
      case ModelTypes.CAPTION_OBJECTS:
        return "OBJECT TO TEXT";
      case ModelTypes.IMAGE_TAGGING:
        return "IMAGE CLASSIFICATION";
      case ModelTypes.OBJECT_TAGGING:
        return "OBJECT CLASSIFICATION";
      case ModelTypes.OBJECT_DETECTION:
        return "OBJECT DETECTION";
      case ModelTypes.MULTIMODEL_IMAGE_ENCODING:
        return "SEMANTIC IMAGE SEARCH";
      case ModelTypes.MULTIMODEL_OBJECT_ENCODING:
        return "SEMANTIC OBJECT SEARCH";
      case ModelTypes.INSTANCE_RETRIEVAL:
        return "INSTANCE RETRIEVAL";

      default:
        return "";
    }
  };
  const title = getModelTypeTitle(modelType);

  return (
    <div className={styles.modeltype} style={{ color, backgroundColor }}>
      <div className={styles.modelTypeIcon}>
        {renderModelTypeIcon(modelType, color)}
      </div>
      <div className={styles.modelTypeText} title={title}>
        {title}
      </div>
    </div>
  );
};
export default ModelTypeBadge;
